import React, { useState } from "react";
import DropZoneFileUploader from "../../components/DropZoneFileUploader";
import { useAdminPanel } from "./AdminPanelCore";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);


const AdminUpload = () => {
  const { files, alerts, setFiles, dayjs, pushAlert } = useAdminPanel(); 
  const [showUploader, setShowUploader] = useState(false);

  const handleUploadSuccess = (uploadedFiles) => {
    if (!uploadedFiles || uploadedFiles.length === 0) return;

    const normalized = uploadedFiles.map((file) => ({
      id: file.id || file.file_id,
      name: file.name || file.filename,
      uploadedAt: file.created_at || new Date().toISOString(),
      tasks: file.tasks || {},
    }));

    setFiles((prev) => [...normalized, ...prev]);
    pushAlert("File uploaded successfully", "success");
  };

  return (
    <div className="container py-4">
      {alerts.map((a) => (
        <div key={a.id} className={`alert alert-${a.type}`}>
          {a.msg}
        </div>
      ))}

      <h3 className="mb-3">📤 Upload Files</h3>
      <button className="btn btn-primary mb-3" onClick={() => setShowUploader(true)}>
        + Upload File
      </button>

      <DropZoneFileUploader
        show={showUploader}
        handleClose={() => setShowUploader(false)}
        onUploadSuccess={handleUploadSuccess}
      />

      <ul className="list-group">
        {files.map((f) => (
          <li key={f.id} className="list-group-item d-flex justify-content-between">
            <span>{f.name}</span>
            <small>{dayjs.utc(f.uploadedAt, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY HH:mm")
            }</small>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminUpload;
